import { fetchWrapper } from "../helpers"

export const contactService = {
  getById,
  create,
}

const baseUrl = `${process.env.BASE_URL}/api/vendor/contact`

function getById(id) {
  return fetchWrapper.get(`${baseUrl}?id=${id}`)
}

function create(params) {
  return fetchWrapper.post(baseUrl, params)
}
